import AdvancedSearchV from '../view/recordm.view.advancedsearch.js';

// The "Presenter" responsible for showing the advanced search form
//

// * `core`: a cob.app instance
// * `moduleBaseUri`: the base uri for this module
// * `entityM`: the definitionM that you are using to search.
// * `advSearchM`: The advance search Model
// * `$container` : the jquery HTML wrapper for the enclosing element
var AdvancedSearchP = function(core, moduleBaseUri, entityM, advSearchM, $container, callbacks) {

    var _loadingKey = core.getLoadingKey();

    var _advancedSearchView = new AdvancedSearchV(core, $container, entityM, {
        goToSimpleSearch: function() {
            callbacks.goToSimpleSearch();
        },
        doSearch: function(searchParameters) {
            _doSearch(searchParameters);
        }
    });

    var _doSearch = function(searchParameters) {
        var currentQueryParameters = JSON.stringify(searchParameters),
            hasQueryChanged = (JSON.stringify(advSearchM.getSearchParameters()) !== currentQueryParameters);

        if (hasQueryChanged) {
            callbacks.updateUri({searchParameters})

        } else {
            // if the search or active view haven't changed do a simple refresh
            advSearchM.refresh();
        }
    };

    var _onSearchFinished = function(e, data) {
        if (data && data.advancedSearch) {
            core.hideLoading(_loadingKey, "AdvancedSearchP._onSearchFinished");
        }
    };

    const _search = function(query) {
        var currentView = callbacks && callbacks.getCurrentVisualization(),
            sortedColumn = {};

        if (query !== undefined) {
            core.showLoading(_loadingKey, "AdvancedSearchP._init");

            if (currentView) {
                sortedColumn = currentView.getSortedColumn() || sortedColumn;
            }

            _advancedSearchView.setSearchParameters(query);
            advSearchM.doSearch(query, 0, sortedColumn.column, sortedColumn.ascending);
        }
    };

    var _init = function(query) {
        core.subscribe("recordm:search:finished", _onSearchFinished);

        _advancedSearchView.start();
        _advancedSearchView.setFocusOnSearch();

        _search(query);
    };

    var _resume = function() {
        _advancedSearchView.start();
        _advancedSearchView.setFocusOnSearch();

        core.subscribe("recordm:search:finished", _onSearchFinished);
    };

    var _pause = function() {
        core.unsubscribe("recordm:search:finished", _onSearchFinished);

        //we call hideLoading to clear any ongoing search before pausing
        core.hideLoading(_loadingKey, "AdvancedSearchP._pause");

        _advancedSearchView.stop();
    };

    var _destroy = function() {
        core.unsubscribe("recordm:search:finished", _onSearchFinished);

        //we call hideLoading to clear any ongoing search before exiting
        core.hideLoading(_loadingKey, "AdvancedSearchP._destroy");

        _advancedSearchView.destroy();
    };

    return{
        name: "advance-search",

        init: _init,
        pause: _pause,
        resume: _resume,
        destroy: _destroy,

        refresh: function() {
            advSearchM.refresh();
        },

        prepareView: _advancedSearchView.setFocusOnSearch,
        doSearch: _search
    };
};

export default AdvancedSearchP;
